import React, { Fragment, useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
} from 'reactstrap';

import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import ServiceTableData from './ServiceTableData';
import { Breadcrumbs } from '../../AbstractElements';
import { fetchHistory, fetchServices } from '../../actions/axios-actions';
import { AxiosInterceptor, AxiosInterceptor2 } from '../../utils/axios-utils';
import {
  HistoryColumns,
  frontDeskServiceColumns,
  otherDepartmentServiceColumns,
} from '../../Data/Services';
import Loader from '../../CommonElements/Loader';
import TimelineTab from './TimelineTab';
import { config } from '../../config';
import 'react-toastify/dist/ReactToastify.css';
import CommonModal from '../../_core/Ui-kits/Modals/common/modal';
import { CircleIcon, CloseIcon, OpenIcon } from '../../Data/Icons';
import socketManager from '../../utils/socket';

const ServicePageContain = () => {
  const [socket, setSocket] = useState(null);
  const [data, setData] = useState([]);
  const [frontDeskServiceData, setFrontDeskServiceData] = useState([]);
  const [historyData, setHistoryData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setsearchText] = useState("");
  const [departmentName, setDepartmentName] = useState("Front Desk");
  const [selRequestType, setSelRequestType] = useState(false);
  const [selRequestStatus, setSelRequestStatus] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const handleModal = () => setIsModal(!isModal);
  const [isAddModal, setIsAddModal] = useState(false);
  const [addModalTab, setAddModalTab] = useState('Maintenance');
  const [maintenanceForm, setMaintenanceForm] = useState({
    reason: '',
    description: '',
    roomNo: '',
  });
  const [maintenanceLoading, setMaintenanceLoading] = useState(false);
  const [maintenanceRoomNoError, setMaintenanceRoomNoError] = useState('');
  const [maintenanceDescriptionError, setMaintenanceDescriptionError] = useState('');
  const [housekeepingForm, setHousekeepingForm] = useState({ roomNo: '' });
  const [housekeepingLoading, setHousekeepingLoading] = useState(false);
  const [housekeepingRoomNoError, setHousekeepingRoomNoError] = useState('');
  const [rooms, setRooms] = useState([]);
  const [roomsLoading, setRoomsLoading] = useState(false);
  const [essentials, setEssentials] = useState([]);
  const [essentialsLoading, setEssentialsLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedQuantity, setSelectedQuantity] = useState(0);
  const navigate = useNavigate();

  const handleMaintenanceSubmit = async () => {
    if (!maintenanceForm.description.trim()) {
      setMaintenanceDescriptionError('Description is required');
      return;
    }
    setMaintenanceDescriptionError('');
    if (!maintenanceForm.roomNo) {
      setMaintenanceRoomNoError('Please Specify Room number properly');
      return;
    }
    setMaintenanceRoomNoError('');
    setMaintenanceLoading(true);
    try {
      await AxiosInterceptor2.post('newservicerequest', {
        // department: '5e4e2e97a4deb400105aa1ce',
        department: 'Maintenance',
        fromFrontdesk: true,
        hotelId: localStorage.getItem('hotelId'),
        isFromFD: true,
        requests: [
          {
            title: 'Maintenance Request',
            note:
              maintenanceForm.reason == 'Custom'
                ? maintenanceForm.description
                : maintenanceForm.reason + ' - ' + maintenanceForm.description,
          },
        ],
        description: maintenanceForm.description,
        totalAmount: 0,
        roomNo: Number(maintenanceForm.roomNo),
      });
      setIsAddModal(false);
      setMaintenanceForm({ reason: '', description: '', roomNo: '' });
      setMaintenanceDescriptionError('');
      fetchServices({
        page: 1,
        size: perPage,
        setFrontDeskServiceData,
        setData,
        setHistoryData,
        setTotalRows,
        setLoading,
        departmentName:"Housekeeping"
      });
    } catch (err) {
      toast.error(
        err?.response?.data?.result?.message || 'Failed to submit request',
        { position: toast.POSITION.TOP_RIGHT },
      );
    } finally {
      setMaintenanceLoading(false);
    }
  };

  const handleHousekeepingSubmit = async () => {
    if (!housekeepingForm.roomNo) {
      setHousekeepingRoomNoError('Please Specify Room number properly');
      return;
    }
    setHousekeepingRoomNoError('');
    setHousekeepingLoading(true);
    try {
      await AxiosInterceptor2.post('/newservicerequest', {
        department: "Housekeeping",
        fromFrontdesk: true,
        hotelId: localStorage.getItem('hotelId'),
        isFromFD: true,
        requests: [
          {
            price: selectedItem?.amount || 0,
            quantity: selectedQuantity,
            title: selectedItem?.name,
          },
        ],
        roomNo: Number(housekeepingForm.roomNo),
        totalAmount: (selectedItem?.amount || 0) * selectedQuantity,
        isHouseKeepingRequest: true,
      });
      setIsAddModal(false);
      setHousekeepingForm({ roomNo: '' });
      setSelectedItem(null);
      setSelectedQuantity(0);
      fetchServices({
        page: 1,
        size: perPage,
        setFrontDeskServiceData,
        setData,
        setHistoryData,
        setTotalRows,
        setLoading,
        departmentName:"Housekeeping"
      });
    } catch (err) {
      toast.error(
        err?.response?.data?.result?.message || 'Failed to submit request',
        { position: toast.POSITION.TOP_RIGHT },
      );
    } finally {
      setHousekeepingLoading(false);
    }
  };

  let x = "Preferences"
  let Light = "Low";
  if (modalData.viewtype == "minibar") x = "Stock Your Mini Bar";
  if (modalData.viewtype == "room_preference") x = "Room Preferences";

  if(modalData.preferenceData?.lightPercentage === 0) Light = "Off";
  if(modalData.preferenceData?.lightPercentage !=0 &&  modalData.preferenceData?.lightPercentage > 10) Light = "Low";
  if(modalData.preferenceData?.lightPercentage >= 50 && modalData.preferenceData?.lightPercentage <= 60) Light = "Medium";
  if(modalData.preferenceData?.lightPercentage > 65 ) Light = "High";

  useEffect(() => {
    const socket = socketManager.getSocket();
    socketManager.connect(); // Ensures it's connected (once)

    const handleConnect = () => {
      console.log("Connected Inside");
    };

    const handleServiceRequest = (data) => {
      console.log("service_request_notify received:", data);
      fetchServices({
        page: 1,
        size: perPage,
        setFrontDeskServiceData,
        setData,
        setHistoryData,
        setTotalRows,
        setLoading,
      });
    };

    // Register event listeners
    socketManager.on("connect", handleConnect);
    socketManager.on("service_request_notify", handleServiceRequest);

    // Cleanup
    return () => {
      console.log("Cleaning up service_request_notify listener...");
      socketManager.off("connect", handleConnect);
      socketManager.off("service_request_notify", handleServiceRequest);
    };
  }, []); // ⬅️ Run once only on mount

  useEffect(() => {
    fetchServices({
      page: 1,
      size: perPage,
      setFrontDeskServiceData,
      setData,
      setHistoryData,
      setTotalRows,
      setLoading,
    });
    return () => {
      setFrontDeskServiceData({});
      setData({});
      setHistoryData({});

    };
  }, []);

  useEffect(() => {
    if (isAddModal && rooms.length === 0) {
      setRoomsLoading(true);
      AxiosInterceptor2.get('getAllRooms')
        .then((res) => {
          setRooms(res.data?.result?.data || []);
        })
        .catch(() => toast.error('Failed to load rooms'))
        .finally(() => setRoomsLoading(false));
    }
  }, [isAddModal]);

  useEffect(() => {
    if (
      isAddModal &&
      addModalTab === 'Housekeeping' &&
      essentials.length === 0
    ) {
      setEssentialsLoading(true);
      AxiosInterceptor2.get('getCategoryComponentws3')
        .then((res) => {
          const items = res.data?.result?.data?.component?.Essentials || [];
          setEssentials(items);
        })
        .catch(() => toast.error('Failed to load housekeeping items'))
        .finally(() => setEssentialsLoading(false));
    }
  }, [isAddModal, addModalTab]);

  const handleSearch = (e) => {
    e.preventDefault();
    if (departmentName === "History") {
      fetchHistory({
        size: perPage,
        searchText,
        departmentName,
        setFrontDeskServiceData,
        setData,
        setHistoryData,
        setTotalRows,
        setLoading,
      });
    } else {
      fetchServices({
        searchText,
        departmentName,
        setFrontDeskServiceData,
        setData,
        setHistoryData,
        setTotalRows,
        setLoading,
      });
    }
  };

  const handlePageChange = (page) => {
    if (departmentName === "History") {
      fetchHistory({
        page,
        size: perPage,
        searchText,
        departmentName,
        setFrontDeskServiceData,
        setData,
        setHistoryData,
        setTotalRows,
        setLoading,
        requestStatus: selRequestStatus.value,
      });
    } else {
      fetchServices({
        page,
        size: perPage,
        searchText,
        departmentName,
        setFrontDeskServiceData,
        setData,
        setHistoryData,
        setTotalRows,
        setLoading,
      });
    }
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    if (departmentName === "History") {
      fetchHistory({
        page,
        departmentName,
        searchText,
        setHistoryData,
        setData,
        setTotalRows,
        setLoading,
        size: newPerPage,
      });
    }
    else {
      fetchServices({
        page,
        size: newPerPage,
        searchText,
        departmentName,
        setFrontDeskServiceData,
        setData,
        setHistoryData,
        setTotalRows,
        setLoading,
      });
    }
    setPerPage(newPerPage);
  };

  const setValue = async (e, value) => {
    e.preventDefault();
    let departmentNameTemp = null;
    departmentNameTemp = value;
    setDepartmentName(value);

    if (value === "History") {
      await fetchHistory({
        departmentName: departmentNameTemp,
        searchText,
        setHistoryData,
        setData,
        setTotalRows,
        setLoading,
      });
    }
    else {

      await fetchServices({
        departmentName: departmentNameTemp,
        searchText,
        setFrontDeskServiceData,
        setData,
        setTotalRows,
        setLoading,
      });
    }
  };
  const handlefieldChange = (obj) => {
    console.log(obj);
    setSelRequestType(obj);
    fetchServices({
      requestStatus: selRequestStatus ? selRequestStatus.value : false,
      packageType: obj.value,
      searchText,
      departmentName,
      setFrontDeskServiceData,
      setData,
      setHistoryData,
      setTotalRows,
      setLoading,
      size:perPage
    });
  };

  const handleStatusChange = (obj) => {

    console.log(obj);


    setSelRequestStatus(obj);

    if (departmentName === "History") {
      fetchHistory({
        packageType: selRequestType ? selRequestType.value : "",
        requestStatus: obj ? obj.value : false,
        searchText,
        departmentName,
        setFrontDeskServiceData,
        setData,
        setHistoryData,
        setTotalRows,
        setLoading,
        size:perPage
      });
    } else {

      fetchServices({
        packageType: selRequestType ? selRequestType.value : "",
        requestStatus: obj ? obj.value : false,
        searchText,
        departmentName,
        setFrontDeskServiceData,
        setData,
        setHistoryData,
        setTotalRows,
        setLoading,
        size:perPage
      });
    }

  };

  const handleRowClicked = (row) => {
    setIsModal(true);
    setModalData(row);
  };

  const navigateTo360 = (rowData) =>
    navigate(
      `/profile-360?e=${btoa(rowData.emailId || '')}&i=${btoa(
        rowData.reservationId || '',
      )}&linkedInUrl=${btoa(rowData?.linkedInUrl || '')}&lN_slt_skip=${btoa(rowData.isLinkedInSelectionSkip || '')}`,
    );

  return (
    <Fragment>
      <Breadcrumbs parent="Pages" title="Services">
        {isModal &&
          (modalData.viewtype === 'minibar' ||
            modalData.viewtype === 'room_preference') && (
            <CommonModal
              isOpen={isModal}
              title={x}
              toggler={handleModal}
              disabledButtombuttons={true}
            >
              {modalData.viewtype === 'minibar' && (
                <ul>
                  <li className="d-flex align-items-center justify-content-between p-2">
                    <span className="">
                      <b className="d-flex align-items-center dark-span justify-content-center">
                        {'Service Request'}
                      </b>
                    </span>
                    <span className="">
                      <b className="text-start dark-span">{'Quantity'}</b>
                    </span>
                  </li>
                  {modalData.requests?.map((request) => (
                    <li className="d-flex align-items-center justify-content-between p-2">
                      <span className="">
                        <span className="d-flex align-items-center justify-content-center ">
                          {modalData.status === 'completed' ||
                          modalData.status === 'assigned' ? (
                            <>
                              {console.log(modalData.status)}
                              <OpenIcon className="me-2" />
                              <span className="mt-1 dark-span right-font">
                                &nbsp;&nbsp;{request.name}
                              </span>
                            </>
                          ) : (
                            <>
                              {console.log(modalData.status)}
                              <CircleIcon className="me-3" />
                              <span className="mt-1 dark-span right-font">
                                &nbsp;&nbsp;{request.name}
                              </span>
                            </>
                          )}
                        </span>
                      </span>
                      <b className="text-start dark-span ">
                        {request.quantity}
                      </b>
                    </li>
                  ))}
                </ul>
              )}
              {modalData.viewtype === 'room_preference' && (
                <>
                  {Object.keys(modalData.preferenceData).length > 0 && (
                    <>
                      {modalData.preferenceData.sleepQuality.length > 0 && (
                        <li className="d-flex align-items-center justify-content-between p-2">
                          <span className="">
                            <span className="d-flex align-items-center justify-content-between text-left">
                              {modalData.status === 'completed' ||
                              modalData.status === 'assigned' ? (
                                <>
                                  {console.log(modalData.status)}
                                  <OpenIcon className="me-2" />
                                  <span className=" mt-1 dark-span  right-font ">
                                    &nbsp;&nbsp;{"Sleep Quantity"}
                                  </span>
                                </>
                              ) : (
                                <>
                                  {console.log(modalData.status)}
                                  <CircleIcon className="me-3" />
                                  <span className=" mt-1 dark-span right-font ">
                                    &nbsp;&nbsp;{"Sleep Quantity"}
                                  </span>
                                </>
                              )}
                            </span>
                          </span>
                          <span
                            className="text-start dark-span left-font  text-end"
                            style={{ maxWidth: '65%' }}
                          >
                            {modalData.preferenceData?.sleepQuality.map(
                              (e, i) =>
                                e.key +
                                (i + 1 ==
                                modalData.preferenceData?.sleepQuality.length
                                  ? ''
                                  : ', '),
                            )}
                          </span>
                        </li>
                      )}

                      {modalData.preferenceData.pillowType.name && (
                        <li className="d-flex align-items-center justify-content-between p-2">
                          <span className="">
                            <span className="d-flex align-items-center justify-content-center ">
                              {modalData.status === 'completed' ||
                              modalData.status === 'assigned' ? (
                                <>
                                  <OpenIcon className="me-2" />
                                  <span className=" mt-1 dark-span right-font">
                                    &nbsp;&nbsp;
                                    {modalData.preferenceData.pillowType.name}
                                  </span>
                                </>
                              ) : (
                                <>
                                  <CircleIcon className="me-3" />
                                  <span className=" mt-1 dark-span right-font">
                                    &nbsp;&nbsp;
                                    {modalData.preferenceData.pillowType.name}
                                  </span>
                                </>
                              )}
                            </span>
                          </span>
                          <span className="text-start dark-span left-font">
                            {modalData.preferenceData.pillowType.key}
                          </span>
                        </li>
                      )}
                      {modalData.preferenceData.roomSelection.name && (
                        <li className="d-flex align-items-center justify-content-between p-2">
                          <span className="">
                            <span className="d-flex align-items-center justify-content-center">
                              {modalData.status === 'completed' ||
                              modalData.status === 'assigned' ? (
                                <>
                                  <CircleIcon className="me-2" />
                                  <span className=" mt-1 dark-span  right-font">
                                    &nbsp;&nbsp;
                                    {
                                      modalData.preferenceData.roomSelection
                                        .name
                                    }
                                  </span>
                                </>
                              ) : (
                                <>
                                  <CircleIcon className="me-3" />
                                  <span className=" mt-1 dark-span  right-font">
                                    &nbsp;&nbsp;
                                    {
                                      modalData.preferenceData.roomSelection
                                        .name
                                    }
                                  </span>
                                </>
                              )}
                            </span>
                          </span>
                          <span className="text-start dark-span left-font">
                            {modalData.preferenceData.roomSelection.key}
                          </span>
                        </li>
                      )}
                      {modalData.preferenceData.typeOfWine.name && (
                        <li className="d-flex align-items-center justify-content-between p-2">
                          <span className="">
                            <span className="d-flex align-items-center justify-content-center">
                              {modalData.status === 'completed' ||
                              modalData.status === 'assigned' ? (
                                <>
                                  <CircleIcon className="me-2 " />
                                  <span className=" mt-1 dark-span   right-font ">
                                    &nbsp;&nbsp;
                                    {modalData.preferenceData.typeOfWine.name}
                                  </span>
                                </>
                              ) : (
                                <>
                                  <CircleIcon className="me-3" />
                                  <span className=" mt-1 dark-span  right-font">
                                    &nbsp;&nbsp;
                                    {modalData.preferenceData.typeOfWine.name}
                                  </span>
                                </>
                              )}
                            </span>
                          </span>
                          <span className="text-start dark-span left-font">
                            {modalData.preferenceData.typeOfWine.key}
                          </span>
                        </li>
                      )}
                      <hr />

                      <li className="d-flex align-items-center justify-content-between p-2">
                        <span className=" dark-span right-font">
                          {modalData.preferenceData.calmingMusic.name}
                        </span>
                        <span className="text-start dark-span left-font">
                          {modalData.preferenceData.calmingMusic.key}
                        </span>
                      </li>

                      <li className="d-flex align-items-center justify-content-between p-2">
                        <span className="dark-span right-font">
                          {modalData.preferenceData.whiteNoise.name}
                        </span>
                        <span className="text-end  dark-span left-font">
                          {modalData.preferenceData.whiteNoise.key}
                        </span>
                      </li>

                      <li className="d-flex align-items-center  justify-content-between p-2">
                        <span className="dark-span right-font">
                          {modalData.preferenceData?.temperatureUnit ==
                          'fahrenheit'
                            ? 'Fahrenheit'
                            : 'Celsius'}
                        </span>
                        <span className="text-start dark-span left-font">
                          {modalData.preferenceData?.temperatureUnit ==
                          'fahrenheit'
                            ? modalData.preferenceData?.temperature
                            : modalData.preferenceData?.temperature}
                        </span>
                      </li>

                      <li className="d-flex align-items-center justify-content-between p-2">
                        <span className="dark-span right-font">
                          {'Lights  '}
                        </span>
                        <span className="text-start dark-span left-font">
                          {Light}
                        </span>
                      </li>
                      <li className="d-flex align-items-center justify-content-between p-2">
                        <span className="dark-span right-font">
                          {'Color  '}
                        </span>
                        <span className="text-start">
                          <span
                            style={{
                              display: 'block',
                              width: '20px',
                              height: '20px',
                              borderRadius: '50%',
                              borderWidth: '1px',
                              borderColor: 'black',
                              borderStyle: 'solid',
                              margin: '5px',
                              background: `rgb(${modalData.preferenceData?.lightColorRed}, ${modalData.preferenceData?.lightColorGreen}, ${modalData.preferenceData?.lightColorBlue})`,
                              cursor: 'pointer',
                            }}
                          >
                            {' '}
                            &nbsp;&nbsp;&nbsp;
                          </span>
                        </span>
                      </li>

                      <li className="d-flex align-items-center justify-content-between p-2">
                        <span className="dark-span right-font">
                          {'Music  '}
                        </span>
                        <span className="text-start dark-span left-font">
                          {modalData.preferenceData?.music.name}
                        </span>
                      </li>
                    </>
                  )}
                </>
              )}
            </CommonModal>
          )}
        <div className="social-tab p-0" style={{ float: 'right' }}>
          <form onSubmit={(e) => handleSearch(e, { searchText })}>
            <InputGroup>
              <Input
                className="form-control"
                type="text"
                onChange={(e) => setsearchText(e.target.value)}
                value={searchText}
                placeholder="Search......."
              />
              <span className="input-group-text">
                <i
                  className="fa fa-search"
                  onClick={(e) => handleSearch(e, { searchText })}
                ></i>
              </span>
            </InputGroup>
          </form>
        </div>
      </Breadcrumbs>
      {isAddModal && (
        <CommonModal
          isOpen={isAddModal}
          title="Add Request"
          toggler={() => setIsAddModal(false)}
          disabledButtombuttons={true}
        >
          <Nav tabs className="mb-3">
            <NavItem>
              <NavLink
                className={addModalTab === 'Maintenance' ? 'active' : ''}
                style={{ cursor: 'pointer' }}
                onClick={() => setAddModalTab('Maintenance')}
              >
                Maintenance
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={addModalTab === 'Housekeeping' ? 'active' : ''}
                style={{ cursor: 'pointer' }}
                onClick={() => setAddModalTab('Housekeeping')}
              >
                Housekeeping
              </NavLink>
            </NavItem>
          </Nav>

          {addModalTab === 'Maintenance' && (
            <Form>
              <FormGroup>
                <Label>Reason</Label>
                <Input
                  type="select"
                  value={maintenanceForm.reason}
                  onChange={(e) =>
                    setMaintenanceForm({
                      ...maintenanceForm,
                      reason: e.target.value,
                      description: '',
                    })
                  }
                >
                  <option value="">Select reason</option>
                  <option value="HVAC">HVAC</option>
                  <option value="TV">TV</option>
                  <option value="Lights">Lights</option>
                  <option value="Custom">Custom</option>
                </Input>
              </FormGroup>
              <FormGroup>
                <Label>Description</Label>
                <Input
                  type="textarea"
                  value={maintenanceForm.description}
                  onChange={(e) => {
                    setMaintenanceDescriptionError('');
                    setMaintenanceForm({
                      ...maintenanceForm,
                      description: e.target.value,
                    });
                  }}
                  placeholder="Enter description"
                  invalid={!!maintenanceDescriptionError}
                />
                {maintenanceDescriptionError && (
                  <div className="invalid-feedback">{maintenanceDescriptionError}</div>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Room No</Label>
                <Input
                  type="select"
                  value={maintenanceForm.roomNo}
                  onChange={(e) => {
                    setMaintenanceRoomNoError('');
                    setMaintenanceForm({
                      ...maintenanceForm,
                      roomNo: e.target.value,
                    });
                  }}
                  invalid={!!maintenanceRoomNoError}
                  disabled={roomsLoading}
                >
                  <option value="" disabled>{roomsLoading ? 'Loading...' : 'Select room'}</option>
                  {rooms.map((room) => (
                    <option key={room.roomNo} value={room.roomNo}>
                      {room.roomNo}
                    </option>
                  ))}
                </Input>
                {maintenanceRoomNoError && (
                  <div className="invalid-feedback">{maintenanceRoomNoError}</div>
                )}
              </FormGroup>
              <Button
                color="primary"
                onClick={handleMaintenanceSubmit}
                disabled={maintenanceLoading}
              >
                {maintenanceLoading ? 'Submitting...' : 'Submit'}
              </Button>
            </Form>
          )}

          {addModalTab === 'Housekeeping' && (
            <Form>
              <FormGroup>
                <Label>Room No</Label>
                <Input
                  type="select"
                  value={housekeepingForm.roomNo}
                  onChange={(e) => {
                    setHousekeepingRoomNoError('');
                    setHousekeepingForm({ roomNo: e.target.value });
                  }}
                  invalid={!!housekeepingRoomNoError}
                  disabled={roomsLoading}
                >
                  <option value="" disabled>{roomsLoading ? 'Loading...' : 'Select room'}</option>
                  {rooms.map((room) => (
                    <option key={room.roomNo} value={room.roomNo}>
                      {room.roomNo}
                    </option>
                  ))}
                </Input>
                {housekeepingRoomNoError && (
                  <div className="invalid-feedback">{housekeepingRoomNoError}</div>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Item</Label>
                {essentialsLoading ? (
                  <Loader />
                ) : (
                  <Input
                    type="select"
                    value={selectedItem?._id || ''}
                    onChange={(e) => {
                      const found = essentials.find(
                        (i) => i._id === e.target.value,
                      );
                      setSelectedItem(found || null);
                      setSelectedQuantity(found ? 1 : 0);
                    }}
                  >
                    <option value="">Select item</option>
                    {essentials.map((item) => (
                      <option key={item._id} value={item._id}>
                        {item.name}
                      </option>
                    ))}
                  </Input>
                )}
              </FormGroup>
              {selectedItem && (
                <FormGroup>
                  <Label>
                    Quantity
                    <span
                      className="text-muted ms-2"
                      style={{ fontSize: '0.85em' }}
                    >
                      (Max: {selectedItem.maxQuantityPerRoom})
                    </span>
                  </Label>
                  <div className="d-flex align-items-center gap-2">
                    <Button
                      size="sm"
                      color="secondary"
                      disabled={selectedQuantity === 0}
                      onClick={() => setSelectedQuantity((q) => q - 1)}
                    >
                      −
                    </Button>
                    <span style={{ minWidth: '24px', textAlign: 'center' }}>
                      {selectedQuantity}
                    </span>
                    <Button
                      size="sm"
                      color="secondary"
                      disabled={
                        selectedQuantity >= selectedItem.maxQuantityPerRoom
                      }
                      onClick={() => setSelectedQuantity((q) => q + 1)}
                    >
                      +
                    </Button>
                  </div>
                </FormGroup>
              )}
              <Button
                color="primary"
                className="mt-3"
                onClick={handleHousekeepingSubmit}
                disabled={
                  housekeepingLoading || !selectedItem || selectedQuantity === 0
                }
              >
                {housekeepingLoading ? 'Submitting...' : 'Submit'}
              </Button>
            </Form>
          )}
        </CommonModal>
      )}
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <div className="pb-0">
                <TimelineTab
                  handleSearch={handleSearch}
                  changeSearchText={(e) => setsearchText(e.target.value)}
                  changeTabCallback={(e, value) => setValue(e, value)}
                  activeTab={departmentName}
                  searchText={searchText}
                  handlefieldChange={handlefieldChange}
                  handleStatusChange={handleStatusChange}
                  onMaintenanceAdd={() => setIsAddModal(true)}
                />
              </div>
              <CardBody>
                <div className="order-history table-responsive">
                  {frontDeskServiceData && departmentName === 'Front Desk' && (
                    <DataTable
                      responsive={true}
                      columns={frontDeskServiceColumns}
                      data={frontDeskServiceData}
                      progressPending={loading}
                      progressComponent={<Loader />}
                      pagination
                      paginationServer
                      paginationTotalRows={totalRows}
                      paginationDefaultPage={currentPage}
                      onChangeRowsPerPage={handlePerRowsChange}
                      onChangePage={handlePageChange}
                      paginationRowsPerPageOptions={[
                        10, 15, 20, 25, 30, 50, 100,
                      ]}
                      searching={true}
                    />
                  )}

                  {frontDeskServiceData && departmentName === "History" && (
                    <DataTable
                      responsive={true}
                      columns={HistoryColumns}
                      data={historyData}
                      progressPending={loading}
                      progressComponent={<Loader />}
                      pagination
                      paginationServer
                      paginationTotalRows={totalRows}
                      paginationDefaultPage={currentPage}
                      onChangeRowsPerPage={handlePerRowsChange}
                      onChangePage={handlePageChange}
                      paginationRowsPerPageOptions={[
                        10, 15, 20, 25, 30, 50, 100,
                      ]}
                      searching={true}
                      onRowClicked={handleRowClicked}
                    /> 
                  )}

                  {data &&
                    departmentName !== 'Front Desk' &&
                    departmentName !== 'History' &&
                    departmentName !== 'Maintenance' && (
                      <DataTable
                        responsive={true}
                        columns={otherDepartmentServiceColumns}
                        data={
                          data &&
                          data.sort((a, b) => b.createdAtUnix - a.createdAtUnix)
                        }
                        progressPending={loading}
                        progressComponent={<Loader />}
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        paginationDefaultPage={currentPage}
                        onChangeRowsPerPage={handlePerRowsChange}
                        onChangePage={handlePageChange}
                        paginationRowsPerPageOptions={[
                          10, 15, 20, 25, 30, 50, 100,
                        ]}
                        searching={true}
                        // onRowClicked={handleRowClicked}
                        // onRowClicked={navigateTo360}
                      />
                    )}

                  {departmentName === 'Maintenance' && (
                    <DataTable
                      responsive={true}
                      columns={[]}
                      data={[]}
                      progressPending={loading}
                      progressComponent={<Loader />}
                      pagination
                    />
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      <style jsx global>{`
        .order-history .rdt_Table .rdt_TableHead h6,
        .order-history .rdt_Table .rdt_TableHead .h6 {
          text-align: center;
        }

        .dark-span {
          color: black;
        }

        .right-font {
          font-size: 15px !important;
          font-weight: lighter !important;
          opacity: 0.8 !important;
        }

        .left-font {
          font-size: 15px !important;
          font-weight: normal !important;
        }
      `}</style>
    </Fragment>
  );
};
export default ServicePageContain;
